import { Link } from "react-router-dom";
import type { CastMember } from "@/types";

export default function CastStrip({ cast }: { cast: CastMember[] }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {cast.map((member) => (
        <Link
          key={member.id}
          to="/category/cast"
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
        >
          <div className="h-14 w-14 flex-shrink-0 overflow-hidden rounded-full bg-background-200">
            <img
              src={member.avatar}
              alt={`出轨同学会演员${member.name}饰${member.role}`}
              title={`出轨同学会 ${member.name} 饰 ${member.role}`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="min-w-0">
            <p className="font-heading text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
              {member.name}
            </p>
            <p className="mt-0.5 font-label text-xs text-accent-700">饰 {member.role}</p>
            <p className="mt-1 line-clamp-1 font-label text-xs text-foreground-500">{member.bio}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}